const features = [
  {
    id: 'tax',
    title: 'Tax-advantaged health strategy (10+ Full Time Employees)',
    body: 'Maximize pre-tax dollars to fund employee health benefits. Reduce your payroll tax burden while offering meaningful coverage your staff will actually use.',
    variant: 'shield',
    iconPath: 'M12 2L4 7v5c0 5.25 3.4 10.16 8 11.36C16.6 22.16 20 17.25 20 12V7l-8-5z',
    fill:"#1A4270"
  },
  {
    id: 'amaze',
    title: 'Amaze Health direct care (9 or fewer employees)',
    body: 'Small team, big benefits. Amaze Health gives your employees virtual and in-person care access at dramatically lower costs than traditional insurance.',
    variant: 'check',
    iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    stroke:"#1A7A6E",
    strokelinecap:"round",
    strokelinejoin:"round",
    strokewidth:"2",
    fill:"none"
  },
  {
    id: 'fees',
    title: 'No hidden fees, no runaround',
    body: 'Our team walks you through every step. You fill out the form, we do the heavy lifting, and we only reach out when we have something real to offer you.',
    variant: 'dollar',
    iconPath:
      'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    stroke:"#C8922A",
    strokelinecap:"round",
    strokewidth:"2",
    fill:"none"
  }
];

export default function ProgramDetails() {
  return (
    <section>
      <h2 className="font-serif fw-bold text-ecec-navy mb-2 details-heading load-fade-up delay-1">
        Built for the people who build Colorado&apos;s future
      </h2>
      <p className="text-secondary details-copy load-fade-up delay-2">
       Whether you run a home child care or a multi-classroom center, there's a path to better health coverage. Here's what you get when you enroll.
      </p>

      <div className="d-flex flex-column gap-3 mb-4 load-fade-up delay-3">
        {features.map((feature) => (
          <article className="feature-card" key={feature.id}>
            <div className={`feature-icon feature-icon-${feature.variant}`} aria-hidden="true">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d={feature.iconPath} fill={feature.fill} stroke={feature.stroke} stroke-linecap={feature.strokelinecap} stroke-linejoin={feature.strokelinejoin} stroke-width={feature.strokewidth} />
              </svg>
            </div>
            <div>
              <h3 className="h6  text-ecec-navyy mb-1">{feature.title}</h3>
              <p className="small p_card text-secondary mb-0">{feature.body}</p>
            </div>
          </article>
        ))}
      </div>

      <aside className="testimonial-box load-fade-up delay-4">
        <p className="testimonial-quote mb-2">
         "We had no idea a program like this existed. Within a week of signing up, we had a clear plan that saved us real money and made our staff feel valued."
        </p>
        <p className="small mb-0 testimonial-attribution">Colorado child care director, Denver Metro</p>
      </aside>
    </section>
  );
}
